import { render, staticRenderFns } from "./pagTable.vue?vue&type=template&id=6f066eb1&scoped=true&"
import script from "./pagTable.vue?vue&type=script&lang=js&"
export * from "./pagTable.vue?vue&type=script&lang=js&"
import style0 from "./pagTable.vue?vue&type=style&index=0&id=6f066eb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f066eb1",
  null
  
)

export default component.exports